import React from 'react';
import PropTypes from 'prop-types';
import ItemDivider from './ItemDivider';
import ItemContent from './ItemContent';

const Item = ({ type, ...props }) => {
    return type === 'divider' ? <ItemDivider /> : <ItemContent {...props} />;
};

Item.propTypes = {
    type: PropTypes.string.isRequired,
};

export default Item;
